import { Component, OnInit } from "@angular/core";
import {
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
  UntypedFormBuilder,
} from "@angular/forms";

import { DaoService } from "src/app/services/dao.service";
import { LstorageService } from "src/app/services/lstorage.service";
import * as jwtDecode from "jwt-decode";
import { CommonModule } from "@angular/common";
import { ToastService } from "src/app/services/toast.service";
import { MatDialogRef } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
@Component({
  selector: "app-userform",
  templateUrl: "./userform.component.html",
  styleUrls: ["./userform.component.scss"],
})
export class UserformComponent implements OnInit {
  dataSource: any;
  userList: any;
  paginator: MatPaginator;
  public created_By: any;
  modified_By: any;
  userid: any;
  public validator = {
    errorMessage: "",
    UniqueUser: false,
  };
  isuserExists = false;
  isedit = false;
  public shown = {
    grid: true,
    Form: false,
  };
  public userEdit = {
    edit: false,
  };

  User = new FormGroup({
    userId: new FormControl(),
    userName: new FormControl(),
    firstName: new FormControl(),
    lastName: new FormControl(),
    gender: new FormControl(),
    email: new FormControl(),
    countryCode: new FormControl(),
    mobile: new FormControl(),
    isSuperAdmin: new FormControl(),
    role: new FormControl(),
    token: new FormControl(),
    isActive: new FormControl(),
    isLock: new FormControl(),
    createdBy: new FormControl(),
    createdOn: new FormControl(),
    modifiedBy: new FormControl(),
    modifiedOn: new FormControl(),
  });
  // user: any;

  constructor(
    private daoService: DaoService,
    private token: LstorageService,
    private fb: UntypedFormBuilder,
    public dialogRef: MatDialogRef<UserformComponent>,
    private toast: ToastService
  ) {}

  ngOnInit() {
    this.daoService.fuserId.subscribe((data: any) => {
      this.userid = data;
    });
    if (this.userid) {
      this.isedit = true;
      this.modified_By = jwtDecode(this.token.getToken());
      this.daoService.getUserById(this.userid).subscribe((data: any) => {
        this.User = this.fb.group({
          userId: [this.userid],
          userName: [
            data.mobile,
            [
              Validators.required,
              Validators.minLength(10),
              Validators.maxLength(10),
              Validators.pattern("[0-9]+$"),
            ],
          ],
          isSuperAdmin: ["true"],
          isActive: ["true"],
          modifiedBy: [this.modified_By.unique_name],
          modifiedOn: ["2019-11-04T18:38:21.751Z"],
        });
      });
    } else {
      this.created_By = jwtDecode(this.token.getToken());
      this.User = this.fb.group({
        userId: [""],
        userName: [
          "",
          [
            Validators.required,
            Validators.minLength(10),
            Validators.maxLength(10),
            Validators.pattern("[0-9]+$"),
          ],
        ],
        // firstName: [''],
        // lastName: [''],
        // gender: [''],
        // email: [''],
        // countryCode: [''],
        mobile: [],
        isSuperAdmin: ["true"],
        role: [""],
        // token: [''],
        isActive: ["true"],
        isLock: ["false"],
        createdBy: [this.created_By.unique_name],
        createdOn: ["2019-10-05T03:47:43.629Z"],
        modifiedBy: [""],
        modifiedOn: ["2019-11-04T18:38:21.751Z"],
      });
      (error) => {
        console.log("Error:" + error);
      };
    }
  }
  createUser() {
    this.validator.UniqueUser = false;
    this.User.value.mobile = this.User.value.userName;
    this.User.value.role = "User";
    if (this.User.value.userId) {
      this.daoService.AddUser(this.User.value).subscribe(
        (data: any) => {
          if (data.isSuccess) {
            //this.daoService.dynamiceditUserList(data);
            //this.userid = data.userId;
            this.daoService.getUserList().subscribe((data: any) => {
              this.daoService.defaultUserList(data);
              this.toast.openSnackBar("User updated successfully", "close");
              this.dialogRef.close();
            });
          } else {
            this.validator.UniqueUser = true;
            this.validator.errorMessage = data.message;
          }
        },
        (error) => {
          console.log(error);
          this.validator.UniqueUser = true;
          this.validator.errorMessage = error.error.userMessage;
        }
      );
    } else {
      this.daoService.AddUser(this.User.value).subscribe(
        (data: any) => {
          if (data.isSuccess) {
            //this.daoService.dynamicUserList(data.data);
            this.daoService.getUserList().subscribe((data: any) => {
              this.daoService.defaultUserList(data);
              this.toast.openSnackBar("User created successfully", "close");
              this.dialogRef.close();
            });
          } else {
            this.validator.UniqueUser = true;
            this.validator.errorMessage = data.message;
          }
        },
        (error) => {
          console.log(error);
          this.validator.UniqueUser = true;
          this.validator.errorMessage = error.error.userMessage;
        }
      );
    }
  }
  closeUserForm() {
    this.dialogRef.close();
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    if (this.User.value.userName.length > 9) {
      return false;
    }
    return true;
  }
}
